// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__uCILA","notes":"Notes_notes__1XGht"};